// extracted by mini-css-extract-plugin
export default {"content":"Nearby_content__oI3sQ","color":"Nearby_color__WZ+YW","title":"Nearby_title__fDuLo"};